var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/InfoModal/index.tsx";
import React, { useCallback, useEffect, useRef } from 'react';
import { BottomSheet, IconClose, Stack } from '@adc/parallax-component-library';
import { RichText } from 'Components/utility';
export const InfoModal = ({
  isOpen,
  title,
  content,
  customBody,
  additionalContent,
  app,
  handleClose,
  customModalStyle,
  onPressLinkContent
}) => {
  const ref = useRef(null);
  const modalStyles = customModalStyle ?? {
    overflow: 'auto',
    minHeight: '20vh',
    maxHeight: '80vh',
    height: 'auto'
  };
  useEffect(() => {
    if (isOpen) {
      ref.current?.present();
    } else {
      ref.current?.dismiss();
    }
  }, [isOpen]);
  const handleDismiss = useCallback(() => {
    handleClose();
  }, [handleClose]);
  return /*#__PURE__*/React.createElement(BottomSheet, {
    ref: ref,
    topNavigationProps: {
      buttonStart: {
        element: /*#__PURE__*/React.createElement(IconClose, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56,
            columnNumber: 20
          }
        }),
        onPress: handleClose,
        label: 'close'
      },
      title
    },
    onBackdropClick: handleDismiss,
    onDismiss: handleDismiss,
    testID: "info-modal",
    enableDynamicSizing: true,
    scrollable: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: modalStyles,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    gridRowGap: "$4",
    flex: 1,
    marginBottom: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }, content && /*#__PURE__*/React.createElement(RichText, {
    text: content,
    color: "$text.100",
    testID: "content",
    onPressLink: onPressLinkContent,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 13
    }
  }), customBody, additionalContent && /*#__PURE__*/React.createElement(RichText, {
    text: additionalContent,
    color: app === 'libreView' ? '$text.60' : '$text.100',
    fontToken: app === 'libreView' ? '$bodySmall.default' : '$bodyBase.default',
    testID: "additionalContent",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 13
    }
  }))));
};